import React from 'react'
import { Snackbar } from '@bitcine/cinesend-theme'
import { StoreContext } from '../../contexts/store'

const SnackbarWrapper = () => {
  const { state } = React.useContext(StoreContext)

  return <Snackbar items={state.messages} alignment='right' />
}

export default SnackbarWrapper
